// @ts-strict-ignore
import React, { ReactNode, useState } from 'react'

import { DeliveryModal } from '@/screens/Delivery/page/ui/DeliveryModal/DeliveryModal'

import { Modal } from '@/shared/ui'

import cl from './delivery-item.module.scss'

export type DeliveryItemProps = {
	icon?: ReactNode
	children?: ReactNode
	deliveryModal?: boolean
	isDelivery?: boolean
}

export const DeliveryItem = ({ icon, children, deliveryModal, isDelivery }: DeliveryItemProps): JSX.Element => {
	const [isOpen, setIsOpen] = useState(false)

	const onClick = () => {
		if (!deliveryModal) return
		setIsOpen(true)
	}

	return (
		<div className={cl.deliveryItem} onClick={onClick}>
			<div className={`${cl.iconWrapper} ${isDelivery ? cl.isDelivery : ''}`}>{icon}</div>
			<div className={`${cl.content} ${isDelivery ? cl.isDelivery : ''}`}>{!!children && <>{children}</>}</div>

			<Modal isOpen={isOpen} onClose={() => setIsOpen(false)} className={cl.modal} contentClassName={cl.modalContent}>
				<DeliveryModal />
			</Modal>
		</div>
	)
}
